import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import { Container } from '@material-ui/core'
import classNames from 'classnames'
import BackButton from './BackButton'
import Typography from '@material-ui/core/Typography'


const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  menuButton: {
    '&:hover': {
      backgroundColor: '#ccc'
    }
  },
  tollbarContainer: {
    paddingLeft: '0 !important',
    paddingRight: '0 !important'
  },
  title: {
    flexGrow: 0,
    fontWeight: 300,
    fontSize: '13px',
    color: '#8E8E95',
    marginRight: '5px'
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar
  },
  toolBarRight: {
    marginLeft: 'auto',
    margin: '0 8px'
  },

  iconGrid: {
    fontSize: '16px', 
    marginRight: '5px'
  }
}))

const Navbar = ({ title }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.toolbar} />
      <AppBar position="fixed" elevation className={classes.navbar}>
        <Container className={classNames(classes.tollbarContainer)}>
          <Toolbar className={classNames(classes.toolbar)}>
              <BackButton />
              <Typography variant="h6" color="primary" noWrap>
                {title || 'Fórum de discussão'}
              </Typography>
              <div className={classes.toolBarRight}></div>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  )
}

export default Navbar
